import { ApolloClient, HttpLink, InMemoryCache, split } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { getMainDefinition } from "@apollo/client/utilities";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { createClient } from "graphql-ws";
import { jwtDecode } from "jwt-decode";

import { keycloak } from "../keycloak";

const API_URL = import.meta.env.VITE_GRAPHQL_API ||  "https://graphql.teclaverde.com/v1/graphql"
const WS_URL = import.meta.env.VITE_WS_GRAPHQL_API || "wss://graphql.teclaverde.com/v1/graphql";

const httpLink = new HttpLink({
  uri: API_URL,
});
const wsLink = new GraphQLWsLink(
  createClient({
    url: WS_URL,
    connectionParams: async () => {
      if (keycloak.token && keycloak.isTokenExpired()) {
        try {
          await keycloak.updateToken(30); 
        } catch (error) {
          console.error("Failed to refresh token", error);
        }
      }
      const userInfo: UserSessionJWT = jwtDecode(keycloak?.token as string);
      console.log(userInfo)
      return {
        // headers: {
        //   Authorization: keycloak?.token ? `Bearer ${keycloak.token}` : "",
        //   "x-hasura-role": userInfo?.realm_access?.roles?.[0] || "",
        //   //  "x-hasura-admin-secret":"WFpyxApRmHd4L94"
        // },
       headers: {
        "x-hasura-role": "public",
        "x-hasura-admin-secret": "YWFpyxApRmHd4L94",
      },
      };
    },
  })
);

export const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  httpLink
);

const authLink = setContext(async (_, { headers }) => {
  if (keycloak.token && keycloak.isTokenExpired()) {
    try {
      await keycloak.updateToken(30);
    } catch (error) {
      console.error("Failed to refresh token", error);
    }
  }
  const userInfo: UserSessionJWT = jwtDecode(keycloak?.token as string);
 console.log(userInfo)

  return {
    // headers: {
    //   ...headers,
    //   Authorization: keycloak?.token ? `Bearer ${keycloak?.token}` : "",
    //    "x-hasura-role": userInfo?.realm_access?.roles?.[0] || "",
    //   //  "x-hasura-admin-secret":"WFpyxApRmHd4L94"
    // },
      headers: {
        ...headers,
        "x-hasura-role": "public",
        "x-hasura-admin-secret": "YWFpyxApRmHd4L94",
      },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(splitLink),
  cache: new InMemoryCache(),
});
